module.exports = __webpack_public_path__ + "img/appy.6dda8fc9.png";